import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { MoralisProvider } from "react-moralis";
import { NotificationProvider } from 'web3uikit';
import * as serviceWorker from "./serviceWorker";
import { CanvasProvider } from "./CanvasContext";


ReactDOM.render(
  <React.StrictMode>
    <CanvasProvider>
      <BrowserRouter>
     
        <App />
        
      </BrowserRouter>
      </CanvasProvider>
     
   
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
